function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M478-880q63 0 123 19t110 54q14 10 16 26.5t-9 29.5q-11 14-28 16t-31-9q-36-28-84.5-42T478-800q-99 0-170.5 52T194-623q-8 15-23.5 21t-30.5-1q-16-8-21-24t3-31q51-94 141.5-158T478-880zm-3 800q-111 0-203.5-59.5T123-296q-8-15-4-32t18-26q14-9 30-4.5t24 18.5q45 79 119 129.5T475-160q135 0 230-94t95-227q-2-16 11-28t29-11q20 1 29.5 12t10.5 29q0 83-31.5 156T762-196q-55 54-129 85T475-80zM336-581l-22 22q-9 9-8.5 21t9.5 21q9 9 21 9t21-9l35-35q12-12 12-28t-12-28l-36-36q-8-8-21-8t-21 8q-9 9-9 21t9 21l22 21zm504-19q-33 0-56.5-23.5T760-680q0-36 22-71t41-64q3-5 7.5-7t9.5-2q5 0 9.5 2t7.5 7q19 29 41 64t22 71q0 33-23.5 56.5T840-600zm-215 19l21-21q9-9 9-21t-9-21q-9-9-21-9t-21 9l-36 36q-12 12-12 28t12 28l36 36q9 9 21.5 8.5T647-517q9-9 9-21.5t-9-21.5l-22-21zM480-480zM325-280q7 0 14.5-4t11.5-10q22-30 55-48t74-18q41 0 74 18t55 48q4 6 11 10t14 4q18 0 26.5-16t-3.5-34q-26-39-73-64.5T480-420q-26 0-51 5.5T382-398l-142-82q0-16-8-30t-22-22q-22-12-45.5-5.5T128-510q-12 22-5.5 45.5T150-428q14 8 30 8t30-8l118 68q-8 8-14 16l-12 16q-11 17-2.5 32.5T325-280z"
  }));
};
const SvgSick = styled(BaseComponent).withConfig({
  displayName: "Sick__SvgSick",
  componentId: "sc-1gkjfmz-0"
})(["outline:none;"]);
SvgSick.isIcon = true;
export default SvgSick;